if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        console.log('--- ProductForm: Initializing... ---');

        this.form = this.querySelector('form');
        if (!this.form) {
          console.error('--- ProductForm Error: Form element not found! ---');
          return;
        }

        // Safety check to prevent constructor crash
        const variantInput = this.variantIdInput;
        if (variantInput) {
          variantInput.disabled = false;
        } else {
          console.warn('--- ProductForm: variantIdInput [name=id] not found. This might be normal for some product types. ---');
        }

        this.form.addEventListener('submit', (e) => {
          console.log('--- Elite Interceptor: SHIELDING SUBMIT FROM YAMPI ---');
          e.stopImmediatePropagation();
          this.onSubmitHandler(e);
        }, { capture: true });
        
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        
        this.submitButton = this.querySelector('.js-essence-add-to-cart');
        if (this.submitButton) {
          this.submitButtonText = this.submitButton.querySelector('span') || this.submitButton;
          if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
        
        // AJAX URL padrão para adicionar ao carrinho sem ser interceptado pelo Yampi no nível do Form
        this.atomicSyncUrl = window.routes?.cart_add_url || '/cart/add.js';
        
        console.log('--- ProductForm: Initialized Successfully ---');
      }

      showSuccessState() {
        console.log('--- ProductForm: ATTEMPTING SUCCESS STATE PILL ---');
        const button = this.submitButton;
        const buttonText = this.submitButtonText || button;
        
        if (!button) {
          console.error('--- ProductForm: Cannot show success state, button missing ---');
          return;
        }

        const originalHtml = button.innerHTML;
        button.classList.add('success');
        button.innerHTML = `
          <div class="essence-success-content">
            <span class="success-icon-circle">
              <svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
            </span>
            adicionado
          </div>
        `;
        
        console.log('--- ProductForm: Success UI active! ---');

        setTimeout(() => {
          button.classList.remove('success');
          button.innerHTML = originalHtml;
          console.log('--- ProductForm: Success UI reverted ---');
        }, 3000);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        evt.stopPropagation(); // Stop other listeners from hijacking the redirect
        
        console.log('--- ProductForm: Click Intercepted! Staying on page... ---');

        if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        if (this.submitButton) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          const loadingSpinner = this.querySelector('.loading__spinner');
          if (loadingSpinner) loadingSpinner.classList.remove('hidden');
        }

            // PHASE 1: ATOMIC LOCK (Enable Shield & Window Guard)
            window.__essence_lock = true;
            console.log('--- Essence Lock: SHIELD & WINDOW GUARD ACTIVATED ---');
            
            // Block window.open during the lock period
            const originalOpen = window.open;
            window.open = function() {
              if (window.__essence_lock) {
                console.warn('--- Essence Shield: BLOCKED WINDOW.OPEN HIJACK ---');
                return null;
              }
              return originalOpen.apply(this, arguments);
            };

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];

            const formData = new FormData(this.form);
            if (this.cart) {
              formData.append(
                'sections',
                this.cart.getSectionsToRender().map((section) => section.id)
              );
              formData.append('sections_url', window.location.pathname);
              this.cart.setActiveElement(document.activeElement);
            }
            
            // ALWAYS request header section to update count bubble
            formData.append('sections', 'header');
            
            config.body = formData;

            // Standard URL to allow Yampi fetch listeners to sync the cart
            const cartUrl = this.atomicSyncUrl;

            fetch(cartUrl, config)
              .then((response) => response.json())
              .then((response) => {
                if (response.status) {
                  console.error('--- ProductForm: API Error response ---', response);
                  window.__essence_lock = false; // Release lock on error
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    errors: response.errors || response.description,
                    message: response.message,
                  });
                  this.handleErrorMessage(response.description);

                  if (this.submitButton) {
                    const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                    if (soldOutMessage) {
                      this.submitButton.setAttribute('aria-disabled', true);
                      this.submitButtonText.classList.add('hidden');
                      soldOutMessage.classList.remove('hidden');
                    }
                  }
                  this.error = true;
                  return;
                }

                // Update Header Cart Bubble
                if (response.sections && response.sections.header) {
                  const html = new DOMParser().parseFromString(response.sections.header, 'text/html');
                  const newBubble = html.getElementById('cart-icon-bubble');
                  const currentBubble = document.getElementById('cart-icon-bubble');
                  if (newBubble && currentBubble) {
                    currentBubble.innerHTML = newBubble.innerHTML;
                  }
                }

                console.log('--- ProductForm: AJAX Success! Holding Lock for 2.5s... ---');
                
                // KEEP THE LOCK for 2.5 seconds to prevent Yampi hijack
                setTimeout(() => {
                  window.__essence_lock = false;
                  window.open = originalOpen; // Restore window.open
                  console.log('--- Essence Lock: SHIELD RELEASED ---');
                }, 2500);

            console.log('--- ProductForm: Showing Success Modal... ---');
            
            // Get product data for the modal
            const productTitle = this.querySelector('[name="id"]')?.dataset?.productTitle || 
                                document.querySelector('.product__title h1')?.innerText || 
                                'Produto Adicionado';
            const productImage = document.querySelector('.product__media img')?.src || 
                                 this.closest('.product')?.querySelector('img')?.src || '';

            if (typeof openCartSuccessModal === 'function') {
              openCartSuccessModal({
                title: productTitle,
                image: productImage
              });
            } else {
              this.showSuccessState();
            }
            
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });
            
            this.error = false;
            
            // STAY ON PAGE - SHOW MODAL
            console.log('--- ProductForm: STAYING ON PAGE & SHOWING MODAL ---');

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              // Delay closing quick add to let the success modal show
              setTimeout(() => {
                quickAddModal.hide(true);
                if (this.cart) this.cart.renderContents(response);
              }, 500);
            } else if (this.cart) {
              this.cart.renderContents(response);
              // Force drawer update but don't open it (let the modal handle the choice)
              const drawer = document.querySelector('cart-drawer');
              if (drawer && typeof drawer.renderContents === 'function') {
                drawer.renderContents(response);
              }
            }
          })
          .catch((e) => {
            console.error('--- ProductForm: FETCH ERROR ---', e);
          })
          .finally(() => {
            if (this.submitButton) {
              this.submitButton.classList.remove('loading');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              const loadingSpinner = this.querySelector('.loading__spinner');
              if (loadingSpinner) loadingSpinner.classList.add('hidden');
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form ? this.form.querySelector('[name=id]') : null;
      }
    }
  );
}
